<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <template
                    v-if="showFolders"
                    v-for="mat in allMaterialFolders"
                    :key="'folder_' + mat.id"
                >
                    <a class="col-sm-12 col-md-3">
                        <div class="card border">
                            <a
                                target="_blank"
                                class="material-link"
                                @click="goToFolder(mat.id)"
                            >
                                <div class="card-body text-center">
                                    <div v-if="mat.image != null">
                                        <img
                                            :src="'/' + mat.image"
                                            class="preview-img4"
                                        />
                                        <i
                                            class="fas fa-folder folder-indicator"
                                        ></i>
                                    </div>
                                    <i
                                        v-else
                                        class="fas fa-folder preview-img4 default-folder"
                                    ></i>
                                    <h5 class="m-0 p-2">{{ mat.name }}</h5>
                                </div>
                            </a>
                            <div class="hover-indicator-folder">
                                Go to folder &nbsp;&nbsp;<i
                                    class="fas fa-arrow-right"
                                ></i>
                            </div>
                            <div class="action-btns" v-if="user.role.id == 1">
                                <button
                                    class="edit-btn"
                                    @click="edit(mat, 'folder')"
                                >
                                    <i class="fas fa-pen"></i> Edit
                                </button>
                                <button
                                    class="delete-btn"
                                    @click="deleteItem(mat, 'folder')"
                                >
                                    <i class="fas fa-trash"></i> Delete
                                </button>
                            </div>
                        </div>
                    </a>
                </template>
                <template v-for="mat in allMaterials" :key="'file_' + mat.id">
                    <a class="col-sm-12 col-md-3">
                        <div class="card border">
                            <a
                                :href="'/' + mat.attachments"
                                target="_blank"
                                class="material-link"
                            >
                                <div class="card-body text-center">
                                    <img
                                        :src="'/' + mat.image"
                                        class="preview-img4"
                                    />
                                    <h5 class="m-0 p-2">{{ mat.name }}</h5>
                                </div>
                            </a>
                            <div class="hover-indicator-folder">
                                Download File &nbsp;&nbsp;<i
                                    class="fas fa-download"
                                ></i>
                            </div>
                            <div class="action-btns" v-if="user.role.id == 1">
                                <button
                                    class="edit-btn"
                                    @click="edit(mat, 'file')"
                                >
                                    <i class="fas fa-pen"></i> Edit
                                </button>
                                <button
                                    class="edit-btn"
                                    @click="edit(mat, 'file_folder')"
                                >
                                    <i class="fas fa-folder-tree"></i> Change
                                    Folder Location
                                </button>
                                <button
                                    class="delete-btn"
                                    @click="deleteItem(mat, 'file')"
                                >
                                    <i class="fas fa-trash"></i> Delete
                                </button>
                            </div>
                        </div>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";

export default {
    props: ["showFolders"],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let allMaterials = computed(function () {
            return store.state["material"].allMaterials;
        });

        let allMaterialFolders = computed(function () {
            return store.state["material"].allMaterialFolders;
        });

        onMounted(() => {});

        return {
            store,
            user,
            allMaterials,
            allMaterialFolders,
        };
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {
        goToFolder(id) {
            console.log(id);
            this.$emit("goToFolder", id);
        },
        edit(mat, type) {
            this.$emit("edit", { type: type, data: mat });
        },
        deleteItem(mat, type) {
            this.$emit("delete", { type: type, data: mat });
        },
    },
};
</script>
<style scoped>
a {
    text-decoration: none !important;
}
.preview-img4 {
    object-fit: contain;
}

.material-link {
    cursor: pointer;
}

.material-link i {
    display: flex;
    justify-content: center;
    align-items: center;
}

.material-link .preview-img4 {
    font-size: 5rem;
}

.folder-indicator {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #ff9800;
    font-size: 45px;
    opacity: 0.6;
}

.default-folder {
    font-size: 5rem;
    color: #ff9800;
    opacity: 0.6;
}

.with-bg .card {
    background: white;
    box-shadow: 1px 1px 6px 1px #c0c0c0;
}
.hover-indicator-folder {
    display: none;
}
.card:hover > .hover-indicator-folder {
    position: absolute;
    height: 50px;
    width: 100%;
    background: #303030bd;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 19px;
    color: white;
    font-weight: 500;
    text-transform: uppercase;
    cursor: pointer;
    top: 0;
}

.action-btns {
    display: flex;
    justify-content: center;
    gap: 5px;
    margin-bottom: 10px;
}

.edit-btn {
    border: none;
    padding: 5px 10px;
    font-size: 15px;
    border-radius: 15px;
    background: no-repeat;
    font-weight: 700;
}

.edit-btn:hover,
.delete-btn:hover {
    text-decoration: underline;
}

.delete-btn {
    border: none;
    padding: 5px 10px;
    font-size: 15px;
    border-radius: 15px;
    background: no-repeat;
    font-weight: 700;
    color: #e4362c;
}
</style>
